import { forwardRef } from 'react';
import PropTypes from 'prop-types';

const SuccessIllustration = forwardRef(function SuccessIllustration(props, ref) {
  const { size = 48, ...others } = props;

  return (
    <svg
      ref={ref}
      {...others}
      fill="none"
      height={size}
      viewBox="0 0 49 48"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24.5" cy="24" fill="#27AE60" r="24" />
      <path
        clipRule="evenodd"
        d="M34.5 17.5177L21.2164 32L14.5 24.7556L16.1878 23.229L21.2073 28.6432L32.804 16L34.5 17.5177Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
});

SuccessIllustration.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SuccessIllustration;
